import React, { useLayoutEffect, useRef } from 'react'
import { Modal, Box, TextareaAutosize, Button, Select, MenuItem } from '@mui/material';
import changebackgroundImg from "../SelfPublish/menuIcons/background.svg";
import BackgroundModal from './BackgroundModal/BackgroundModal';
import BookPreview from './BookPreview/BookPreview';
import Custombookpreview from '../CustomCharector/Custombookpreview';
import HandprintView from '../HandPrint/HandprintView';
import Worldbookview from '../thisisyourworld/HandprintView';

export function RightToolbar(props) {
  const self = useRef({}).current;
  const backgroundColorRef = useRef(null);
  const backgroundImageRef = useRef(null);
  const backgroundSplitRef = useRef(null);

  self.props = props;

  useLayoutEffect(() => {
    initialConstruct.bind(self)('RightToolbar', props);
    self.backgroundColorRef = backgroundColorRef;
    self.backgroundImageRef = backgroundImageRef;
    self.backgroundSplitRef = backgroundSplitRef;
  }, []);

  const changeBackground = (index) => {
    let { pages, applyBackground } = props;
    let indexObj = pages[index]?.backgroundObj||{};
    const setBackground = (background, isUrl = false, splitMode = false) => {
      applyBackground({
        backgroundImage: '',
        backgroundColor: '',
        [isUrl ? 'backgroundImage' : 'backgroundColor']: background,
        splitMode
      });
    };
    let dialog = confirm(() => <BackgroundModal
      colorRef={backgroundColorRef}
      imageRef={backgroundImageRef}
      defaultImage={indexObj.backgroundImage}
      defaultColor={indexObj.backgroundColor || "#ffffff"}
      splitRef={backgroundSplitRef}
    />, "Change Background", {
      ok: "Apply",
      class: "BackgroundModal",
      parentclass: "BackgroundModal"
    });
    dialog.promise.then(() => {
      if (backgroundImageRef.current.files.length) {
        let splitMode = backgroundSplitRef.current.checked;
        backgroundImageRef.current.files[0].toBase64().then((src) => {
          // console.log({setBackground:splitMode,splitMode});
          setBackground(`url(${src})`, true, splitMode);
        });
      } else {
        setBackground(backgroundColorRef.current.value);
      }
    });
  }

  const previewBook = () => {
    let { onPreview,pages,getPayload,bookDetails,message,onUpdate,saveBook,closablePreview,params,onPreviewClose } = props;
    if(props.params.name == 'customcharacter-book' ){
      let modal = alert(
        (props) => (
          
          <Custombookpreview 
            alert={props} 
            pages={pages} 
            getPayload={getPayload} 
            bookDetails={bookDetails} 
            message={message} 
            onUpdate={onUpdate} 
            saveBook={saveBook} 
            closablePreview={closablePreview}
            onPreviewClose={onPreviewClose}
            bookname={params.name}
          />
        ),
        "",
        "model",
        {
          footer: false,
          class: "BookPreview characterView col-12 col-md-10 col-lg-10 col-xl-8",
          parentclass: params.name+" BookPreview row",
          options: {},
        }
      );
    }
    else if(props.params.name == 'world-book' ){
      let modal = alert(
        (props) => (
          
          <Worldbookview 
            alert={props} 
            pages={pages} 
            getPayload={getPayload} 
            bookDetails={bookDetails} 
            message={message} 
            onUpdate={onUpdate} 
            saveBook={saveBook} 
            closablePreview={closablePreview}
            onPreviewClose={onPreviewClose}
            bookname={params.name}
          />
        ),
        "",
        "model",
        {
          footer: false,
          class: "BookPreview characterView handprintView col-12 col-md-10 col-lg-10 col-xl-8",
          parentclass: params.name+" BookPreview row",
          options: {},
        }
      );
    }
    else if(props.params.name == 'handprint-book' ){
      let modal = alert(
        (props) => (

          <HandprintView
            alert={props}
            pages={pages}
            getPayload={getPayload}
            bookDetails={bookDetails}
            message={message}
            onUpdate={onUpdate}
            saveBook={saveBook}
            closablePreview={closablePreview}
            onPreviewClose={onPreviewClose}
            bookname={params.name}
          />
        ),
        "",
        "model",
        {
          footer: false,
          class: "BookPreview characterView handprintView col-12 col-md-10 col-lg-10 col-xl-8",
          parentclass: params.name+" BookPreview row",
          options: {},
        }
      );
    }
    else{
      let modal = alert(
        (props) => (
          <BookPreview 
            alert={props} 
            pages={pages} 
            getPayload={getPayload} 
            bookDetails={bookDetails} 
            message={message} 
            onUpdate={onUpdate} 
            saveBook={saveBook} 
            closablePreview={closablePreview}
            onPreviewClose={onPreviewClose}
            bookname={params.name}
          />
        ),
        "",
        "model",
        {
          footer: false,
          class: "BookPreview col-12 col-md-10 col-lg-10 col-xl-8",
          parentclass: params.name+" BookPreview row",
          options: {},
        }
      );
    }
    
  }

  let { saveBook, onPreview, currentIndex, children = () => (""), hasBtns={},bookDetails={}, closablePreview=true } = props;
  let { editbackground=true,needsave=true,needpreview=true } = hasBtns;
  let Extras = children || (() => (""));
  return (
    <div className='row no-gutters'>
      <div className='toolbar' style={{marginLeft:'auto'}}>
        {
          editbackground && <Button
            className='changeBG'
            variant="outlined"
            onClick={() => changeBackground(currentIndex)}
            title="Change Background">
            <img src={changebackgroundImg} />
            <small>Background</small>
          </Button>
        }
        {
          needsave && <Button className="save"
            variant="outlined"
            onClick={() => saveBook()} >
            <i className='fa fa-save'></i>
            <small>Save</small>
          </Button>
        }
        {
          needpreview && <Button className="save"
            variant="outlined"
            id="previewBook"
            onClick={() => previewBook()} >
            <i className="fas fa-eye"></i>
            <small>Preview</small>
          </Button>
        }
        { needsave && <Extras />}
      </div>
    </div>
  )
}

export default RightToolbar
